import { Grid, Collapse, Tab } from "@material-ui/core";
import { Send } from "@material-ui/icons";
import CommonButton from "app/common/Component/Button/CommonButton";
import GlobitsPagingAutocomplete from "app/common/form/GlobitsPagingAutocomplete";
import GlobitsTextField from "app/common/form/GlobitsTextField";
import { TYPE_CARD } from "app/common/LocalConst";
import { useFormikContext } from "formik";
import React from "react";
import { observer } from "mobx-react";
import { pagingHealthCareService } from "app/services/HealthCareService";
import { TabContext, TabList, TabPanel } from "@material-ui/lab";
import { pagingClientCard } from "app/services/ClientCardService";
import { pagingDrug } from "app/services/DrugService";
import IconImages from "app/common/Icon/IconImages";
import { REGISTER_SERVICE_SIGNLE } from "app/appConfig";
const FooterBoxAdvise = observer(
  ({
    showDetails,
    setCurrentTab,
    currentTab,
    uploadMultiple,
    selectedFiles,
    setSelectedFiles,
    // isAddPermission,
  }) => {
    const { values } = useFormikContext();
    const TAB_LIST = [
      ...(!REGISTER_SERVICE_SIGNLE
        ? []
        : [
            {
              tabName: "Dịch vụ",
              content: (
                <>
                  <ServiceBlock />
                </>
              ),
              value: 0,
            },
          ]),

      {
        tabName: "Liệu trình",
        content: (
          <>
            <TreatmentPlanBlock />
          </>
        ),
        value: 1,
      },

      {
        tabName: "Sản phẩm",
        content: (
          <>
            <ProductBlock />
          </>
        ),
        value: 2,
      },
      {
        tabName: "Thẻ trả trước",
        content: (
          <>
            <CardBlock />
          </>
        ),
        value: 3,
      },

      {
        tabName: "Hình ảnh",
        content: (
          <>
            <ImageUploadBlock
              uploadMultiple={uploadMultiple}
              selectedFiles={selectedFiles}
              setSelectedFiles={setSelectedFiles}
            />
          </>
        ),
        value: 4,
      },
    ];
    return (
      <div className="chat-input">
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Collapse in={showDetails} timeout={400} unmountOnExit>
              <Grid
                container
                spacing={1}
                className={`slide-toggle ${showDetails ? "show" : "hide"}`}
              >
                <Grid item xs={12}>
                  <TabContext value={currentTab}>
                    <TabList
                      className="tabs-container-white tab-custom-fee tab-custom-chatbox"
                      onChange={(_, newTabIndex) => {
                        setCurrentTab(newTabIndex);
                      }}
                      variant="scrollable"
                      value={currentTab}
                    >
                      {TAB_LIST.map((tab, index) => (
                        <Tab
                          key={index}
                          className={`item-tabs item-tabs-chatbox  ${
                            index === currentTab ? "item-tabs-active" : ""
                          }`}
                          label={tab.tabName}
                          value={index}
                        />
                      ))}
                    </TabList>
                    {TAB_LIST.map((tab, index) => (
                      <TabPanel
                        component="section"
                        className="p-0"
                        key={tab.value}
                        value={index}
                      >
                        {tab.content}
                      </TabPanel>
                    ))}
                  </TabContext>
                </Grid>
              </Grid>
            </Collapse>
          </Grid>
          <Grid item xs={6} lg={5}>
            <GlobitsTextField
              name="content"
              isTextArea
              rows={3}
              placeholder="Nội dung tư vấn chính..."
              className="input-primary"
              disabled={!values?.patientAdvice}
              debounceTime={300}
            />
          </Grid>
          <Grid item xs={6} lg={4}>
            <GlobitsTextField
              name="internalContent"
              isTextArea
              rows={3}
              placeholder="Ghi chú"
              className="input-note"
              disabled={!values?.patientAdvice}
              debounceTime={300}
            />
          </Grid>

          <Grid item xs={12} lg={3} className="flex align-end gap-2">
            <CommonButton
              type="submit"
              className="btn-primary btn-send-submit"
              fullWidth
              disabled={!values?.patientAdvice}
            >
              <Send />
              Gửi
              {/* {!isMobile &&} */}
            </CommonButton>
          </Grid>
        </Grid>
      </div>
    );
  }
);

const ServiceBlock = observer(() => {
  return (
    <>
      <Grid container spacing={1} className="tab-form-grid">
        <Grid item xs={12} sm={6}>
          <GlobitsPagingAutocomplete
            api={pagingHealthCareService}
            label="Quan tâm"
            multiple
            name="customerInterestedServices"
            renderOption={(item) => (
              <div className="option-item">
                <b>{item?.name || ""}</b> ({item?.code || ""})
              </div>
            )}
            searchObject={{
              isUse: true,
            }}
            filterOptions={(options, state) =>
              options.filter(
                (option) =>
                  option?.name
                    ?.toLowerCase()
                    .includes(state?.inputValue?.toLowerCase()) ||
                  option?.code
                    ?.toLowerCase()
                    .includes(state?.inputValue?.toLowerCase())
              )
            }
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <GlobitsPagingAutocomplete
            api={pagingHealthCareService}
            multiple
            label={"Đã chốt"}
            name="customerConfirmedServices"
            searchObject={{
              isUse: true,
            }}
            renderOption={(item) => (
              <div className="option-item">
                <b>{item?.name || ""}</b> ({item?.code || ""})
              </div>
            )}
            filterOptions={(options, state) =>
              options.filter(
                (option) =>
                  option?.name
                    ?.toLowerCase()
                    .includes(state?.inputValue?.toLowerCase()) ||
                  option?.code
                    ?.toLowerCase()
                    .includes(state?.inputValue?.toLowerCase())
              )
            }
          />
        </Grid>
      </Grid>
    </>
  );
});

const ProductBlock = observer(({ isAddPermission }) => {
  return (
    <>
      <Grid container spacing={1}>
        <Grid item xs={12} md={6}>
          <GlobitsPagingAutocomplete
            api={pagingDrug}
            multiple
            label="Quan tâm"
            searchObject={{
              isUse: true,
            }}
            name={"customerInterestedProducts"}
            renderOption={(item) => (
              <div
                className="flex-wrap gap-1 w-100"
                style={{
                  borderBottom: "1px solid #ccc",
                }}
              >
                <b>{item?.name || ""}</b>({item?.code || ""})
              </div>
            )}
            filterOptions={(options, state) => {
              return options.filter(
                (option) =>
                  option?.code
                    ?.toLowerCase()
                    .includes(state?.inputValue?.toLowerCase()) ||
                  option?.name
                    ?.toLowerCase()
                    .includes(state?.inputValue?.toLowerCase())
              );
            }}
            getOptionLabel={(drug) => {
              const name = drug?.productName || drug?.name;
              const availableAmount = drug?.availableAmount;
              return `${name} ${
                availableAmount > 0
                  ? `- Tồn: ${availableAmount} ${drug?.unit?.name}`
                  : ""
              } `;
            }}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <GlobitsPagingAutocomplete
            api={pagingDrug}
            multiple
            label={"Đã chốt"}
            name={"customerConfirmedProducts"}
            searchObject={{
              isUse: true,
            }}
            renderOption={(item) => (
              <div
                className="flex-wrap gap-1 w-100"
                style={{
                  borderBottom: "1px solid #ccc",
                }}
              >
                <b>{item?.name || ""}</b>({item?.code || ""})
              </div>
            )}
            filterOptions={(options, state) => {
              return options.filter(
                (option) =>
                  option?.code
                    ?.toLowerCase()
                    .includes(state?.inputValue?.toLowerCase()) ||
                  option?.name
                    ?.toLowerCase()
                    .includes(state?.inputValue?.toLowerCase())
              );
            }}
            getOptionLabel={(drug) => {
              const name = drug?.productName || drug?.name;
              const availableAmount = drug?.availableAmount;
              return `${name} ${
                availableAmount > 0
                  ? `- Tồn: ${availableAmount} ${drug?.unit?.name}`
                  : ""
              } `;
            }}
          />
        </Grid>
      </Grid>
    </>
  );
});

const CardBlock = observer(({ isAddPermission }) => {
  return (
    <>
      <Grid container spacing={1}>
        <Grid item xs={12} md={6}>
          <GlobitsPagingAutocomplete
            api={pagingClientCard}
            searchObject={{
              type: TYPE_CARD[0].value,
              isUse: true,
            }}
            multiple
            label="Quan tâm"
            name={"customerInterestedPrepaidCards"}
            renderOption={(item) => (
              <div
                className="flex-wrap gap-1 w-100"
                style={{
                  borderBottom: "1px solid #ccc",
                }}
              >
                <b>{item?.name || ""}</b>({item?.code || ""})
              </div>
            )}
            filterOptions={(options, state) => {
              return options.filter(
                (option) =>
                  option?.name
                    ?.toLowerCase()
                    .includes(state?.inputValue?.toLowerCase()) ||
                  option?.code
                    ?.toLowerCase()
                    .includes(state?.inputValue?.toLowerCase())
              );
            }}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <GlobitsPagingAutocomplete
            api={pagingClientCard}
            searchObject={{
              type: TYPE_CARD[0].value,
              isUse: true,
            }}
            multiple
            label={"Đã chốt"}
            name={"customerConfirmedPrepaidCards"}
            renderOption={(item) => (
              <div
                className="flex-wrap gap-1 w-100"
                style={{
                  borderBottom: "1px solid #ccc",
                }}
              >
                <b>{item?.name || ""}</b>({item?.code || ""})
              </div>
            )}
            filterOptions={(options, state) => {
              return options.filter(
                (option) =>
                  option?.name
                    ?.toLowerCase()
                    .includes(state?.inputValue?.toLowerCase()) ||
                  option?.code
                    ?.toLowerCase()
                    .includes(state?.inputValue?.toLowerCase())
              );
            }}
          />
        </Grid>
      </Grid>
    </>
  );
});

const TreatmentPlanBlock = observer(({ isAddPermission }) => {
  return (
    <>
      <Grid container spacing={1}>
        <Grid item xs={12} md={6}>
          <GlobitsPagingAutocomplete
            api={pagingClientCard}
            multiple
            label="Quan tâm"
            name={"customerInterestedTreatmentCards"}
            searchObject={{
              type: TYPE_CARD[1].value,
              isUse: true,
            }}
            renderOption={(item) => (
              <div
                className="flex-wrap gap-1 w-100"
                style={{
                  borderBottom: "1px solid #ccc",
                }}
              >
                <b>{item?.name || ""}</b>({item?.code || ""})
              </div>
            )}
            filterOptions={(options, state) => {
              return options.filter(
                (option) =>
                  option?.name
                    ?.toLowerCase()
                    .includes(state?.inputValue?.toLowerCase()) ||
                  option?.code
                    ?.toLowerCase()
                    .includes(state?.inputValue?.toLowerCase())
              );
            }}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <GlobitsPagingAutocomplete
            api={pagingClientCard}
            searchObject={{
              type: TYPE_CARD[1].value,
              isUse: true,
            }}
            multiple
            label={"Đã chốt"}
            name={"customerConfirmedTreatmentCards"}
            renderOption={(item) => (
              <div
                className="flex-wrap gap-1 w-100"
                style={{
                  borderBottom: "1px solid #ccc",
                }}
              >
                <b>{item?.name || ""}</b>({item?.code || ""})
              </div>
            )}
            filterOptions={(options, state) => {
              return options.filter(
                (option) =>
                  option?.name
                    ?.toLowerCase()
                    .includes(state?.inputValue?.toLowerCase()) ||
                  option?.code
                    ?.toLowerCase()
                    .includes(state?.inputValue?.toLowerCase())
              );
            }}
          />
        </Grid>
      </Grid>
    </>
  );
});

const ImageUploadBlock = observer(
  ({ selectedFiles, uploadMultiple, setSelectedFiles }) => {
    return (
      <Grid container spacing={1} className="image-upload-block">
        <Grid item md={2} className="flex">
          <label htmlFor="image-upload" className="upload-label">
            <span className="icon">
              <IconImages />
            </span>
          </label>
          {/* <label htmlFor="files-upload" className="upload-label">
            <span className="icon">
              <IconFiles />
            </span>
          </label> */}
          {/* <input
            type="file"
            id="files-upload"
            accept="pdf/*"
            multiple
            onChange={uploadMultiple}
            style={{ display: "none" }}
          /> */}
          <input
            type="file"
            id="image-upload"
            accept="image/*"
            multiple
            onChange={uploadMultiple}
            style={{ display: "none" }}
          />
        </Grid>

        <Grid item md={10}>
          <div className="preview-content">
            {selectedFiles?.length > 0 && (
              <div className="preview-list">
                {selectedFiles.map((img, index) => (
                  <div className="preview-wrapper" key={index}>
                    <img
                      src={URL.createObjectURL(img?.path)}
                      alt={img?.name}
                      className="preview-image"
                    />
                    <button
                      className="remove-btn"
                      type="button"
                      onClick={() => {
                        let newSelectedFile = selectedFiles?.filter(
                          (el) => el?.id !== img?.id
                        );
                        setSelectedFiles([...newSelectedFile]);
                      }}
                    >
                      ✕
                    </button>
                  </div>
                ))}
              </div>
            )}
          </div>
        </Grid>
      </Grid>
    );
  }
);

export default FooterBoxAdvise;
